import React from 'react';
import {Switch,Route} from "react-router-dom";
import Landing from "../pages/landing";
import {Support, Video, Text, Faq, General, VideoEn} from "../pages/support";
import Price from "../pages/price";
import {Demo ,DemoEn} from "../pages/demo";
import WhyBellmeet from "../pages/why-bellmeet";
import {Tools, ToolsEn} from "../pages/tools";
import AboutUs from "../pages/about";
import {OnlineEducation ,OnlineEducationEn ,Interactive ,InteractiveEn ,Onlineclass ,OnlineclassEn ,Fairs ,FairsEn ,Webconference ,WebconferenceEn, Webinar ,WebinarEn ,Meeting ,MeetingEn ,Workshop ,WorkshopEn ,Event , EventEn} from "../pages/content/index"
import {WebService ,WebServiseEn} from "../pages/web-service";
import {useTranslation} from "react-i18next";

const Router = ()=>{
	const { t } = useTranslation('common')
	return(
		<Switch>
			<Route path="/" exact component={Landing} />
			<Route path="/support/video" exact component={t('lang') === 'fa' ? Video : VideoEn} />
			<Route path="/videoEn" exact component={VideoEn}/>
			<Route path="/support/text" exact component={Text} />
			<Route path="/support/general" exact component={General} />
			<Route path="/support/faq" exact component={Faq} />
			<Route path="/support" exact component={Support} />
			<Route path="/price" exact component={Price} />
			<Route path="/demo" exact component={t('lang') === 'fa' ? Demo : DemoEn} />
			<Route path="/why" exact component={WhyBellmeet} />
			<Route path="/tools" exact component={t('lang') === 'fa' ? Tools : ToolsEn} />
			<Route path="/about" exact component={AboutUs} />
			<Route path="/webinar" exact component={t('lang') === 'fa' ? Webinar : WebinarEn} />
			<Route path="/webconference" exact component={t('lang') === 'fa' ? Webconference : WebconferenceEn} />
			<Route path="/fairs" exact component={t('lang') === 'fa' ? Fairs : FairsEn} />
			<Route path="/class" exact component={t('lang') === 'fa' ? Onlineclass : OnlineclassEn} />
			<Route path="/interactive" exact component={t('lang') === 'fa' ? Interactive : InteractiveEn} />
			<Route path="/online" exact component={t('lang') === 'fa' ? OnlineEducation :OnlineEducationEn} />
			<Route path="/meeting" exact component={t('lang') === 'fa' ? Meeting : MeetingEn} />
			<Route path="/workshop" exact component={t('lang') === 'fa' ? Workshop : WorkshopEn} />
			<Route path="/event" exact component={t('lang') === 'fa' ? Event : EventEn} />
			<Route path="/webservice" exact component={t('lang') === 'fa' ? WebService : WebServiseEn} />
		</Switch>
	)
}
export default Router;